<template>
  <el-dialog
    v-dialogDrag
    title="查看排查记录"
    :visible.sync="visible"
    :close-on-click-modal="false"
    class="large-dialog"
  >
    <div class="h-full">
      <div class="flex">
        <el-date-picker
          class="mr-10px"
          v-model="datePickerValue"
          size="small"
          :clearable="true"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
        >
        </el-date-picker>
        <el-button size="small" type="primary" @click="searchList">搜索</el-button>
        <el-button size="small" @click="resetText">重置</el-button>
      </div>
      <el-table
        :data="tableData"
        border
        class="w-full mt-20px"
        :height="tableHeight"
        stripe
        v-loading="loading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="排查周期" width="320px" prop="endTime" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ dealDate(scope.row) }}
          </template>
        </el-table-column>

        <el-table-column label="排查完成时间" prop="troubleshootingResult" show-overflow-tooltip>
          <template>
            /
          </template>
        </el-table-column>
        <el-table-column label="排查结果" prop="troubleshootingResult" show-overflow-tooltip>
          <template>
            /
          </template>
        </el-table-column>
        <el-table-column label="排查人" prop="deadlinePersonName" show-overflow-tooltip>
          <template>
            {{ formData.deadlinePersonName }}
          </template>
        </el-table-column>
        <el-table-column label="排查状态" prop="taskStatusStr" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        layout="total, sizes ,prev, pager, next"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="total"
        class="float-right mt-10px ml-10px mb-10px"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import utils from '@/components/safety/enumField/utils'
import dayjs from 'dayjs'
import { HiddenDangerInvestigationTaskApi } from '@wiz-api/double-prevention-management'

const hiddenDangerInvestigationTaskApi = new HiddenDangerInvestigationTaskApi()
export default {
  name: 'overdue-dialog',
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: true,
      datePickerValue: [],
      detailTypeMap: {
        equip: 'queryDeviceDetail',
        job: 'queryJobActivityDetail',
        base: 'queryBasicManagementDetail',
      },
      searchData: {
        type: '',
        readStatus: '',
        title: '',
      },
      tableData: [],
      loading: false,
      total: 0,
      pageNo: 1,
      pageSize: 15,
      troubleshootingResultList: [],
      troubleshootingStatusList: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 100px)'
    },
    dealDate() {
      return (row) => {
        const start = row.taskTroubleshootCycleStart
          ? dayjs(row.taskTroubleshootCycleStart).format('YYYY-MM-DD HH:mm:ss')
          : '/'
        const end = row.taskTroubleshootCycleEnd
          ? dayjs(row.taskTroubleshootCycleEnd).format('YYYY-MM-DD HH:mm:ss')
          : '/'
        return `${start}-${end}`
      }
    },
  },
  watch: {
    datePickerValue(list) {
      this.searchData.taskTroubleshootStart = list && list.length ? list[0] : ''
      this.searchData.taskTroubleshootEnd = list && list.length ? list[1] : ''
    },
    visible(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  },
  created() {
    this.findList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.TroubleshootingResult',
        'DoublePreventionManagement.DataCategory.roubleshootingStatus',
      ],
      ['troubleshootingResultList', 'troubleshootingStatusList'],
      this
    )
  },
  methods: {
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetText() {
      this.searchData = this.$options.data().searchData
      this.datePickerValue = []
      this.searchList()
    },
    async findList() {
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        isOverdue: true,
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        taskId: this.formData.id,
        ...searchData,
      }
      const [err, res] = await hiddenDangerInvestigationTaskApi.taskDetailsPagedListQuery(data)

      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.loading = false
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
